import { render, staticRenderFns } from "./index.vue?vue&type=template&id=efc29c04&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc29c04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efc29c04')) {
      api.createRecord('efc29c04', component.options)
    } else {
      api.reload('efc29c04', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=efc29c04&scoped=true&", function () {
      api.rerender('efc29c04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/article/study/index.vue"
export default component.exports